import { createMaterializer } from '@wix/materializer'
import { pointers } from '@wix/thunderbolt-becky-types'
import type { CatharsisArgs } from '@wix/thunderbolt-catharsis'
import type { ByRefsis, RawModel } from '../types'
import { REF_COMPONENTS_TEMPLATE_KEY_ASPECT, RESOLVED_REFS_NAMESPACE, SITE_NAMESPACE } from './constants'
import { updateModel, getModelUpdateTransformer } from './modelUpdate'
import { createBatchedRefConsumer, getRefConsumptionTransformer } from './refConsumption'

export const getByRefsis = ({ onInvalidation }: { onInvalidation: CatharsisArgs['onInvalidation'] }): ByRefsis => {
	const rawModel: RawModel = {}

	const transformDataUpdateValue = getModelUpdateTransformer(rawModel)
	const transformRefConsumptionValue = getRefConsumptionTransformer(rawModel)

	const materializer = createMaterializer({
		transform: (value: any, path: Array<string>) => {
			const [namespace] = path
			if (namespace === RESOLVED_REFS_NAMESPACE) {
				return transformRefConsumptionValue(value, path)
			}

			return transformDataUpdateValue(value, path)
		},
	})

	const transaction: ByRefsis['transaction'] = (modelUpdateFn) => {
		const modelUpdateInvalidations = updateModel(materializer, rawModel, modelUpdateFn) as Array<Array<string>>

		const refResolvingInvalidations = materializer.batch((batchUpdate) => {
			const consumeRef = createBatchedRefConsumer(materializer, rawModel, batchUpdate)

			for (const invalidation of modelUpdateInvalidations) {
				const [namespace, aspect, id] = invalidation
				if (namespace === SITE_NAMESPACE) {
					if (aspect === REF_COMPONENTS_TEMPLATE_KEY_ASPECT) {
						consumeRef({
							refCompNamespace: SITE_NAMESPACE,
							refCompId: id,
						})
						continue
					}
					if (aspect === pointers.data.DATA_MAPS.DATA) {
						// materializer.get will get the translated data
						onInvalidation(invalidation, materializer.get)
						continue
					}
				}
			}
		})

		for (const invalidation of refResolvingInvalidations) {
			onInvalidation(invalidation, materializer.get)
		}
	}

	return {
		transaction,
	}
}
